import React, { useCallback } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { FireScreenAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { TaskDescription } from '../components/TaskDescription.tsx';
import { TaskDescriptionParagraph } from '../components/TaskDescriptionParagraph.tsx';
import { ShowMeButton } from '../components/ShowMeButton.tsx';
import { TaskCompleteButton } from '../components/TaskCompleteButton.tsx';
import { CREATE_IDEAS_TOUR_STEP_1_SPOTLIGHT_ID } from '../ui/spotlights/create-ideas/constants.tsx';
import { useActions, useCanCreateAndEditIdeas } from '../services/index.tsx';
import TaskDescriptionRoleRestrictions from '../components/TaskDescriptionRoleRestrictions.tsx';
import { messages } from './createIdeas.messages.tsx';
import { TASK_CREATE_IDEAS } from './constants.tsx';
import type { TaskDefinition } from './types.tsx';

const Description = () => {
	const { formatMessage } = useIntl();
	const { setSpotlightStepId, navigateToAllIdeas } = useActions();
	const canCreateAndEditIdeas = useCanCreateAndEditIdeas();

	const handleShowMeClick = useCallback(() => {
		navigateToAllIdeas();
		setSpotlightStepId(CREATE_IDEAS_TOUR_STEP_1_SPOTLIGHT_ID);
	}, [navigateToAllIdeas, setSpotlightStepId]);

	return (
		<TaskDescription>
			<FireScreenAnalytics attributes={{ taskId: TASK_CREATE_IDEAS }} />
			<TaskDescriptionParagraph>{formatMessage(messages.description)}</TaskDescriptionParagraph>
			<TaskDescriptionRoleRestrictions description={formatMessage(messages.roleRestrictionsText)} />
			{canCreateAndEditIdeas ? (
				<ShowMeButton onClick={handleShowMeClick} taskId={TASK_CREATE_IDEAS} />
			) : (
				<TaskCompleteButton taskId={TASK_CREATE_IDEAS} />
			)}
		</TaskDescription>
	);
};

export const createIdeas = {
	id: TASK_CREATE_IDEAS,
	title: messages.title,
	description: <Description />,
} satisfies TaskDefinition;
